/* eslint-disable no-console, no-undef */
import Glide from '../../vendors/glide.min';

const removeActive = (slider) => {
  const activeItems = slider.querySelectorAll('.selected');
  for (let i = 0; i < activeItems.length; i++) { /* eslint-disable-line no-plusplus */
    activeItems[i].classList.remove('selected');
  }
};

const setActive = (item, onClick) => {
  item.classList.add('selected');
  if (onClick) {
    onClick(item);
  }
};

const init = (options) => {
  const { onSlideClick, slider } = options;
  let galleryItems = slider.querySelectorAll('.image-gallery-item button');
  // Is there more than 1 slide
  if (galleryItems.length > 4) {
    // Add glide
    const glide = new Glide(slider, {
      autoplay: false,
      breakpoints: {},
      gap: 10,
      perView: 4,
      startAt: 0,
      type: 'carousel',
    });
    glide.mount();
    glide.on('move', () => {
      // Catch duplicates
      const img = slider.querySelector('.selected img');
      galleryItems = slider.querySelectorAll('.image-gallery-item button');
      for (let i = 0; i < galleryItems.length; i++) { /* eslint-disable-line no-plusplus */
        if (img.src === galleryItems[i].querySelector('img').src) {
          galleryItems[i].classList.add('selected');
        }
      }
    });
  }

  // Need to catch items that are created by plugin after instantiation
  /* [].map.call(galleryItems, item => item.addEventListener('click', () => {
    removeActive(slider);
    setActive(item, onSlideClick);
  })); */
  const gallerySliderDiv = document.querySelector('.mini-gallery .gallery-slider');
  gallerySliderDiv.addEventListener('click', (event) => {
    const parent = event.target.closest('.image-gallery-item');
    if (parent) {
      const item = parent.querySelector('button');
      removeActive(slider);
      setActive(item, onSlideClick);
    }
  });
  // Set default active
  setActive(galleryItems[0], onSlideClick);
};

const update = (options) => {
  const { slider } = options;
  console.log(slider);
};

export {
  init,
  update,
};
/* eslint-enable no-console, no-undef */
